import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userData: {},
  username: '',
};

const userDataSlice = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload.userData;
      state.username = action.payload.username;
    },
  },
});

export const { setUserData } = userDataSlice.actions;
export default userDataSlice.reducer;
